import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LostDashboardService {

  constructor(private ws: PostmethodService) { }

  getLeadSource(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardLeadSourceFilter");
  }

  getGeography(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardgeogrphicalFilter");
  }

  getStatus(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardCombineFilter");
  }

  getUser(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardUserFilter");
  }

  getProduct(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardProductFilter");
  }

  getZoneCounts(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardCount");
  }

  getGeographyChartCounts(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardGeographyCount");
  }

  getLineChartCount(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardLineChartCount");
  }

  getParentDealerChartCount(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/DashboardParentDealerCount");
  }
  
  getDealersAndOutlets(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardParentOutletFilter");
  }

  getRegionalMgrs(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/regionalManagerFilter");
  }

  getAreaMgrs(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/areaManagerFilter");
  }
}
